<div class="login-container">
  <div>
    <img src="assets/images/cml-logo.PNG" width="400"/>
    <h1 style="text-align: center">Přihlašování ...</h1>
  </div>
</div>
